import { render, staticRenderFns } from "./InformAnswerType.vue?vue&type=template&id=aa813bd4&"
import script from "./InformAnswerType.vue?vue&type=script&lang=js&"
export * from "./InformAnswerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports